<!--
- 我的主页及子组件
- 创建人: lzp
- 创建时间: 2019-09-25
-->
<template lang="html">
  <div class="main-container">
    <Tabs v-model="active_tab" class="left" :animated="false">
      <TabPane label="猜你喜欢" name="like">
        <like v-if="active_tab == 'like'"></like>
      </TabPane>
      <TabPane label="追踪" name="trace">
        <trace v-if="active_tab == 'trace'"></trace>
      </TabPane>
      <TabPane label="收藏" name="bookmark">
        <bookmark v-if="active_tab == 'bookmark'"></bookmark>
      </TabPane>
    </Tabs>
    <div class="right">
      <p><i></i>热门推荐</p>
      <div class="tag-group">
        <div class="tag-item" v-for="item in hot_key" :key="item.id" @click="clickTag(item)">
          {{item.name}}
          <div class="triangle-topright" v-if="item.text_flag == '1'"></div>
        </div>
      </div>
    </div>
    <Modal
        v-model="only_vip_modal"
        :footer-hide="true"
        width="458"
        class="page-modal">
        <img :src="$store.state.static_img_url + 'pic/model/report-upload-model.png'" />
        <p class="p1">亲，这是会员专享哦~</p>
        <p class="p2">成为VIP会员， 查看不受限。</p>
        <a href="javascript:void(0)" class="go-vip-btn" @click="only_vip_modal = false;$router.push({name: 'BuyVip'})">立即成为VIP会员</a>
    </Modal>
    <selectIdentity v-if="select_identity" :selectIdentity="select_identity" @identitycancel="identityCancel" :flow="flow"></selectIdentity>
  </div>
</template>

<script>
import like from './components/like.vue'
import trace from './components/trace.vue'
import bookmark from './components/bookmark.vue'
import SelectIdentity from '@/components/SelectIdentity.vue'
import { collect_mixin } from 'js/collect_mixin.js'
import { getAddPuv } from 'js/addPuv.js'
import { getMeta, hotElement, addFavorite, delFavorite } from '../../service'
export default {
  mixins: [getAddPuv, collect_mixin],
  data() {
    return{
      only_vip_modal: false,
      active_tab: 'like',
      dynview_tag: [],
      report_type: [],
      news_topic_type: [],
      theme_type: [],

      hot_key: [],

      select_identity: false,
      flow: 0
    }
  },
  provide(){
    return{
      dynview_tag: this.dynview_tag,
      report_type: this.report_type,
      news_topic_type: this.news_topic_type,
      theme_type: this.theme_type,

      returnMetaArr: this.returnMetaArr,
      cancelCollect: this.cancelCollect,
      addCollect: this.addCollect,
      showModal: this.showModal,
      is_vip: this.is_vip,
      user: this.user
    }
  },
  computed: {
    is_vip() {
      let user_info
      if(this.user && typeof this.user == 'string'){
        user_info = JSON.parse(this.user)
        return user_info.db_vip == '1' || user_info.vip == '1'
      }else if(this.user && typeof this.user == 'object'){
        return this.user.db_vip == '1' || this.user.vip == '1'
      }else{
        return false
      }
    },
    user() {
      if (this.$store.state.user && typeof this.$store.state.user == 'string') {
        return JSON.parse(this.$store.state.user)
      } else {
        return this.$store.state.user
      }
    },
    never_xuser_type() {
      let user_info
      if(this.user && typeof this.user == 'string'){
        user_info = JSON.parse(this.user)
        if (user_info.xuser_type_id) {
          return false
        } else {
          return true
        }
      }else if(this.user && typeof this.user == 'object'){
        if (this.user.xuser_type_id) {
          return false
        } else {
          return true
        }
      }else{
        return false
      }
    },
    never_subscribe() {
      if (this.$store.state.attention) {
        if (this.$store.state.attention.subscribe.filter((item) => {return item.sub_type == '2'}).length == 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  components: {
    like,trace,bookmark,SelectIdentity
  },
  methods: {
    async getMeta() {
      let res = await getMeta({
        name: ['dynview_tag','report_type','news_topic_type','theme_type']
      }, (error) => {this.$Message.error('元数据请求错误')})
      if (res.status == 'success') {
        this.dynview_tag = res.meta.dynview_tag
         this.report_type = res.meta.report_type
        this.news_topic_type = res.meta.news_topic_type
        this.theme_type = res.meta.theme_type
      } else {
        this.$Message.error(res.message)
      }
    },
    async hotElement() {
      let res = await hotElement({
        size: 20,
        position_id:'4'
      }, (error) => {this.$Message.error('热门数据请求错误')})
      if (res.status == 'success') {
        this.hot_key = res.res
      } else {
        this.$Message.error(res.message)
      }
    },
    returnMetaArr(type, tag_string) { // 返回关联的元数据数组(元数据类型，tag字符串)
      if (!tag_string) {
        return []
      } else {
        let tag_arr = tag_string.split(',')
        return this[type].filter((item)=>{
          return tag_arr.indexOf(item.id) != -1
        })
      }
    },
    clickTag(item) {
      if (item.url) {
        window.open(item.url)
      } else {
        this.$router.replace({ name: 'SearchList', query: { keyword: item.name }})
      }
    },
    showModal() {
      this.only_vip_modal = true
    },
    selectIdentity(flow) { // 弹出框
      this.select_identity = !this.select_identity
      if (flow) {
        this.flow = flow
      }
    },
    identityCancel(value) {
      this.select_identity = value
    }
  },
  created() {
    this.getMeta()
    this.hotElement()
  },
  mounted() {
    setTimeout(() => {
      if (this.$store.state.user_key) {
        if (this.$store.state.current_app_identity_show != 0) {
          if (this.never_xuser_type ) {
            this.selectIdentity()
          } else {
            if (this.never_subscribe) {
              this.selectIdentity(1)
            }
          }
        }
      }
    }, 1000)
    let url = window.location.href
    this.getAddPuv(url)
  },
  watch: {
    never_xuser_type(val) {
      if (val && this.$store.state.current_app_identity_show != 0) {
        setTimeout(() => {
          this.selectIdentity()
        }, 1000)
      }
    },
    never_subscribe(val) {
      if (!this.never_xuser_type && val && this.$store.state.current_app_identity_show != 0) {
        setTimeout(() => {
          this.flow = 1
          this.selectIdentity(1)
        }, 1000)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
commonBgImg1(img_d, img_l) // 背景
  [data-theme='dark'] & {
    background-image: url(img_d)
  }
  [data-theme='light'] & {
    background-image: url(img_l)
  }
inlineBlock()
  display: inline-block
  vertical-align: top
.main-container
  width: 1200px;
  margin: 20px auto;
  display: flex;
  .left
    flex: 1;
    overflow: visible;
    >>>.ivu-tabs-nav-scroll
      commonBgColor(#2A2F42, #FFFAF5)
      .ivu-tabs-tab
        width: 200px;
        commonColor( #BCBDC1, #999)
        text-align: center;
        padding: 15px 16px;
        &.ivu-tabs-tab-active
          commonBgColor(#1F2330, #ffffff);
          commonColor(#fff, #333);
      .ivu-tabs-ink-bar
        top: 1px;
        background-color: rgba(250, 122, 80, 1)
    >>>.ivu-tabs-bar
      margin-bottom: 0;
    >>>.ivu-tabs-content
      commonBgColor(#1F2330, #fff)
  .right
    width: 260px;
    margin-left: 20px;
    padding: 20px 20px 30px 30px;
    commonBgColor(#1F2330, #fff)
    height: fit-content;
    >p
      commonColor(#fff, #333)
      font-size: 18px;
      font-weight: bold;
      i
        display: inline-block
        // vertical-align: bottom
        width: 14px
        height: 14px
        background: no-repeat
        commonBgImg('~pic/report-hot-b.png', '~pic/report-hot-l.png')
        background-size: 100%
        margin-top: 2px
        margin-right: 10px
    .tag-group
      margin-top: 10px;
      .tag-item
        margin-top: 10px;
        float: left;
        padding: 6px 9px;
        line-height: 18px;
        commonBgColor(#2A2F42, #ffffff);
        commonColor(#BCBDC1, rgba(250, 122, 80, 1));
        margin-right: 10px;
        border: 1px solid;
        commonBorderColor(#2A2F42, rgba(250, 122, 80, 1));
        cursor: pointer;
        position: relative;
        .triangle-topright
          width: 16px;
          height: 16px;
          position: absolute;
          top: -1px;
          right: -1px;
          // background-image: url('~pic/main_page/hot-2.png')
          commonBgImg1('~pic/main_page/hot-2.png','~pic/main_page/hot-1.png')
          background-size: 100% 100%;
        &:hover
          commonColor(rgba(250, 122, 80, 1), #ffffff)
          border: 1px solid;
          border-color: rgba(250, 122, 80, 1);
          commonBgColor(inhert, rgba(250, 122, 80, 1))
          .triangle-topright
            commonBgImg1('~pic/main_page/hot-3.png','~pic/main_page/hot-3.png')
.page-modal
  >>> .ivu-modal
    top: 50%
    margin-top: -140px
  >>> .ivu-modal-content
    border-radius: 0
    height: 280px
    background: url('~pic/model/vip-model.png') no-repeat
    background-size: 100%
    .ivu-modal-close
      right: 8px
      top: 8px
      .ivu-icon-ios-close
        color: #ddd
        &:hover
          color: #553204
  >>> .ivu-modal-body
    padding: 0
    text-align: center
    font-size: 0
    img
      width: 120px
      height: 120px
      margin-top: -55px
    .p1
      color: #553204
      font-size: 24px
      font-weight:600
      margin-top: 22px
    .p2
      color: #553204
      font-size: 16px
      margin-top: 12px
    .go-vip-btn
      inlineBlock()
      width:150px
      height:40px
      background:rgba(255,234,197,1)
      border-radius:20px
      color: #553204
      font-size:14px
      text-align: center
      line-height: 40px
      margin-top: 40px
</style>
